import * as React from "react";
/**
 * create a downloadable file
 * @param {Options} options Options
 */
export function useDownload() {
    const download = React.useCallback(({ filename, data, contentType = "application/json" }) => {
        const element = document.createElement("a");
        element.setAttribute("href", `data:${contentType};charset=utf-8,${encodeURIComponent(data)}`);
        element.setAttribute("download", filename);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }, []);
    return download;
}
